import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SettingsDrawerService {
	private readonly _open = signal(false);
	readonly open = this._open.asReadonly();

	openDrawer(): void {
		this._open.set(true);
	}

	closeDrawer(): void {
		this._open.set(false);
	}
}
